const MainLoader = () => {
  return (
    <div className="main-loader">
      <img src={'/images/logo.png'} />
      <div>loading...</div>
    </div>
  )
}

export default MainLoader